import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  OutlinedInput,
  Stack,
  Tab,
  Tabs,
  Typography,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import selected from "../../../assets/svg/selected.svg";
import arrow_check from "../../../assets/svg/arrow_check.svg";
import { useSelector, useDispatch } from "react-redux";
import { fetchSuitesByWarehouseId, fetchMusePartnersByType, createShippingService } from "./shippingService.helper";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { setShippingServiceState } from '../../../store/shippingServiceSlice';
import { getRoutePartners } from "../../../helper/functions";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ maxHeight: "78vh" }}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const LocationCard = ({shippingServiceType, location, isSelected, onSelect }) => {
  console.log(location,"locationnsss")
  return (
    <Card
      onClick={() => onSelect(location.id)}
    sx={{
      border: isSelected ? "2px solid green" : "1px solid #e0e0e0",
        borderRadius: "4px",
      cursor: "pointer",
      position: "relative",
        "&:hover": {
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            backgroundColor:
            location.type === "Traveler"
                ? "#2D9CDB"
                : location.type === "CrowdShipper"
                ? "#F2994A"
                : "#2DC58C",
            width: "fit-content",
            paddingX: "8px",
            paddingY: "4px",
            marginBottom: "5px",
            borderRadius: "2px",
            color: "white",
    }}
  >
          {location.type}
        </Typography>
        <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
           {location.name}
        </Typography>
        <Typography>{shippingServiceType === "standard" ? location.routePartnerMainAddress?.addressLine1 : location.addressLine1}</Typography>
        <Typography>{shippingServiceType === "standard" ? location.routePartnerMainAddress?.addressLine2 : location.addressLine2}</Typography>
        <Typography>{shippingServiceType === "standard" ? location.routePartnerMainAddress?.city : location.city}</Typography>
        <Typography>{shippingServiceType === "standard" ? location.routePartnerMainAddress?.country : location.country}</Typography>
      </CardContent>
    {isSelected && (
      <Box
        sx={{
          position: "absolute",
          top: 0,
            right: -2,
            color: "green",
          }}
        >
          <img src={selected} alt="select" />
          <img
            src={arrow_check}
            alt="select"
            style={{
              position: "absolute",
              top: 5,
              right: 5,
        }}
      />
          {/* <CheckCircleIcon
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
            }}
          /> */}
      </Box>
    )}
    </Card>
);
};

export default function DeliveryPartnerStep({ onBack, onNext, loading }) {

  const shippingServiceData = useSelector((state) => state.shippingService.shippingServiceData);
  console.log(shippingServiceData,"shippingServiceData")
  const { deliveryPartner, wareHouseDetails, routePartner } = shippingServiceData;

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const special_service = [
    "Fast Lane",
    "Greener Shipping",
    "Guaranteed Delivery",
    "International Return",
    "National Return",
    "Ownership Certicifate",
    "Package Inspection",
    "Personal Shopping",
    "Scan Mail",
    "Store Mediation Service",
  ];

  const specialized_service = ["Hazmat", "Medical", "Traveler", "Pick up"];
  const rating = ["5", ">3"];

  // Update Formik initial values to use deliveryPartner object
  const formik = useFormik({
    initialValues: {
      deliveryPartner: deliveryPartner || { id: '', name: '', partnerType: '' },
    },
    validationSchema: Yup.object({
      deliveryPartner: Yup.object({
        id: Yup.string().required('Delivery Partner is required'),
        name: Yup.string().required('Delivery Partner Name is required'),
        partnerType: Yup.string().required('Partner Type is required'),
      }),
    }),
    onSubmit: async (values) => {
      if (shippingServiceData.id) {
        // Update Firestore and Redux if id exists (add or edit mode)
        const response = await createShippingService({
          id: shippingServiceData.id,
          deliveryPartner: values.deliveryPartner,
          updatedAt: new Date().toISOString()
        });
        dispatch(setShippingServiceState({
          ...shippingServiceData,
          deliveryPartner: response.deliveryPartner,
          updatedAt: response.updatedAt
        }));
      }
      if (onNext) onNext();
    },
    enableReinitialize: true,
  });

  // Filter fields as local state (not in Formik)
  const [search, setSearch] = useState("");
  const [destination, setDestination] = useState("");
  const [max_price, setMaxPrice] = useState("");
  const [max_import_fee, setMaxImportFee] = useState("");
  const [max_mile, setMaxMile] = useState("");
  const [checkedSpecialService, setCheckedSpecialService] = useState(
    special_service.reduce((acc, item) => ({ ...acc, [item]: false }), {})
  );
  const [checkedSpecializedService, setCheckedSpecializedService] = useState(
    specialized_service.reduce((acc, item) => ({ ...acc, [item]: false }), {})
  );
  const [checkedRating, setCheckedRating] = useState(
    rating.reduce((acc, item) => ({ ...acc, [item]: false }), {})
  );

  const {
    shippingServiceType,
    // selectedRoutePartner,
  } = shippingServiceData;
  const dispatch = useDispatch();

  // Local state for fetched data
  const [typeAll, setTypeAll] = useState([]);
  const [typeCrowdShipper, setTypeCrowdShipper] = useState([]);
  const [typeTraveler, setTypeTraveler] = useState([]);
  // Remove local loading state declaration
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true); // This line is removed
      console.log(shippingServiceType,"dsfsddsfdsffdg");
      if (shippingServiceType === "standard") {
        const suites = await getRoutePartners([{key: "isCarrierPartner", operator: "==", value: true}]);
        console.log(suites,"suites2222");
        setTypeAll(suites.map(item => ({
          type: "CarrierPartner",
          ...item
        })));
      } else if (shippingServiceType === "crowdshipping") {
        const partners = await fetchMusePartnersByType(routePartner?.id, "CrowdShipper");
        setTypeCrowdShipper(partners.map(item => ({
          type: "CrowdShipper",
          ...item,
          title: item.name,
        })));
      } else if (shippingServiceType === "traveler") {
        const partners = await fetchMusePartnersByType(routePartner?.id, "Traveller");
        setTypeTraveler(partners.map(item => ({
          type: "Traveler",
          ...item,
          title: item.name,
        })));
      }
      // setLoading(false); // This line is removed
    };
    if (shippingServiceType && wareHouseDetails?.id && routePartner?.id) {
      fetchData();
    }
  }, [shippingServiceType, wareHouseDetails?.id, routePartner?.id]);

  // Update handleSpecialServiceChange, handleSpecializedServiceChange, handleRatingChange to use local state
  const handleSpecialServiceChange = (item) => (event) => {
    setCheckedSpecialService((prevChecked) => ({
      ...prevChecked,
      [item]: event.target.checked,
    }));
  };
  const handleSpecializedServiceChange = (item) => (event) => {
    setCheckedSpecializedService((prevChecked) => ({
      ...prevChecked,
      [item]: event.target.checked,
    }));
  };
  const handleRatingChange = (item) => (event) => {
    setCheckedRating((prevChecked) => ({
      ...prevChecked,
      [item]: event.target.checked,
    }));
  };

  // Pass handleSelectAll, handleSelectTraveler, etc. from Formik
  // Update handleSelectAll to set both id, name, and partnerType
  const handleSelectAll = (id) => {
    // Find the selected partner from all available types
    let partnerType = '';
    let selected = typeAll.find((p) => p.id === id);
    if (selected) partnerType = 'RoutePartner';
    if (!selected) {
      selected = [...typeCrowdShipper, ...typeTraveler].find((p) => p.id === id);
      if (selected) partnerType = 'MusePartner';
    }
    formik.setFieldValue('deliveryPartner', { id, name: selected?.name || '', partnerType });
  };
  // const handleSelectTraveler = (id) => {
  //   formik.setFieldValue('selectedtypeTravelerId', id);
  // };
  // const handleSelectCrowShipper = (id) => {
  //   formik.setFieldValue('selectedtypeCrowdShipperId', id);
  // };
  // const handleSelectOther = (id) => {
  //   formik.setFieldValue('selectedtypeOtherId', id);
  // };

  if (loading) {
    return <Box sx={{ p: 4, textAlign: 'center' }}>Loading...</Box>;
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <SimpleBar
            forceVisible="x"
            autoHide={true}
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 356px)",
              minHeight: "calc(100vh - 356)",
            }}
            className="custom-scrollbar"
          >
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Search
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "20vw",
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="search"
                    placeholder="Search Route Partner"
                    name="search"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Destination
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "20vw",
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="destination"
                    placeholder="Ex. Delhi"
                    name="destination"
                    value={destination}
                    onChange={e => setDestination(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Max Pickup Price
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "20vw",
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="max_price"
                    placeholder=""
                    name="max_price"
                    value={max_price}
                    onChange={e => setMaxPrice(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Max Import Fee (Per Consigment)
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "20vw",
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="max_import_fee"
                    placeholder=""
                    name="max_import_fee"
                    value={max_import_fee}
                    onChange={e => setMaxImportFee(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Max Last Mile Delivery Fee
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "20vw",
                    minHeight: "35px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="max_mile"
                    placeholder=""
                    name="max_mile"
                    value={max_mile}
                    onChange={e => setMaxMile(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Special Services
                  </Typography>
                </Box>
                {special_service.map((item) => (
                  <Box key={item}>
                    <FormControlLabel
                      label={item}
                      control={
                        <Checkbox
                          checked={checkedSpecialService[item]}
                          onChange={handleSpecialServiceChange(item)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </Box>
                ))}
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Specialized Services
                  </Typography>
                </Box>
                {specialized_service.map((item) => (
                  <Box key={item}>
                    <FormControlLabel
                      label={item}
                      control={
                        <Checkbox
                          checked={checkedSpecializedService[item]}
                          onChange={handleSpecializedServiceChange(item)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </Box>
                ))}
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Rating
                  </Typography>
                </Box>
                {rating.map((item) => (
                  <Box key={item}>
                    <FormControlLabel
                      label={item}
                      control={
                        <Checkbox
                          checked={checkedRating[item]}
                          onChange={handleRatingChange(item)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  </Box>
                ))}
              </Grid>
            </Stack>
          </SimpleBar>
        </Grid>
        <Grid item xs={12} md={8}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="route partner tabs"
          >
            <Tab label="All" />
            <Tab label="Traveler" />
            <Tab label="CrowdShippers" />
            <Tab label="Other Route Partners" />
          </Tabs>
          <SimpleBar
            forceVisible="x"
            autoHide={true}
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 420px)",
            }}
            className="custom-scrollbar"
          >
            <TabPanel value={value} index={0}>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Your Traveler
                </Typography>
              </Stack>
        <Grid container spacing={2}>
                {typeTraveler.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
              <LocationCard
                shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.deliveryPartner.id}
                      onSelect={handleSelectAll}
              />
            </Grid>
          ))}
            </Grid>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Your CrowShipper
                </Typography>
              </Stack>
              <Grid container spacing={2}>
                {typeCrowdShipper.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
                    <LocationCard
                      shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.deliveryPartner.id}
                      onSelect={handleSelectAll}
                    />
                  </Grid>
                ))}
              </Grid>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Other Route Partners
                </Typography>
              </Stack>
              <Grid container spacing={2}>
                {typeAll.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
                    <LocationCard
                      shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.deliveryPartner.id}
                      onSelect={handleSelectAll}
                    />
                  </Grid>
                ))}
              </Grid>
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Your Traveler
                </Typography>
              </Stack>
              <Grid container spacing={2}>
                {typeTraveler.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
                    <LocationCard
                      shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.selectedtypeTravelerId}
                      onSelect={handleSelectTraveler}
                    />
                  </Grid>
                ))}
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Your CrowShipper
                </Typography>
              </Stack>
              <Grid container spacing={2}>
                {typeCrowdShipper.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
                    <LocationCard
                      shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.selectedtypeCrowdShipperId}
                      onSelect={handleSelectCrowShipper}
                    />
                  </Grid>
                ))}
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Stack direction="row" sx={{ marginTop: 2, marginBottom: 2 }}>
                <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                  Other Partners
                </Typography>
              </Stack>
              <Grid container spacing={2}>
                {typeOther.map((location) => (
                  <Grid item xs={12} sm={12} md={4} key={location.id}>
                    <LocationCard
                      shippingServiceType={shippingServiceType}
                      location={location}
                      isSelected={location.id === formik.values.selectedtypeOtherId}
                      onSelect={handleSelectOther}
                    />
                  </Grid>
                ))}
              </Grid>
            </TabPanel> */}
          </SimpleBar>
        </Grid>
      </Grid>
      {/* Button bar at the bottom */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 3, mt: 6 }}>
        <Button
          type="button"
          onClick={onBack}
          sx={{
            background: '#F4F5F7',
            color: '#A0A4AF',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '16px',
            px: 5,
            py: 1.5,
            boxShadow: 'none',
            textTransform: 'none',
            '&:hover': {
              background: '#E4E6EB',
              color: '#A0A4AF',
              boxShadow: 'none',
            },
          }}
          disabled={loading}
        >
          Back
        </Button>
        <Button
          type="submit"
          sx={{
            background: '#6C2BD7',
            color: '#fff',
            borderRadius: '8px',
            fontWeight: 700,
            fontSize: '16px',
            px: 5,
            py: 1.5,
            boxShadow: 'none',
            textTransform: 'none',
            '&:hover': {
              background: '#5A23B7',
              color: '#fff',
              boxShadow: 'none',
            },
          }}
          disabled={loading}
        >
          Continue
        </Button>
      </Box>
    </form>
  );
}
